import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody } from '../../components/ui';

export const AccountDeleted: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <Card className="max-w-md w-full">
        <CardBody className="text-center py-8">
          <div className="mx-auto w-14 h-14 rounded-full bg-emerald-50 flex items-center justify-center mb-4">
            <svg className="w-7 h-7 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Account deleted</h1>
          <p className="text-sm text-gray-600 mt-3 leading-relaxed">
            Your Passport account has been permanently deleted, including your profile, qualifications, documents, and shares. You have been signed out and cannot sign in to Passport with this account.
          </p>
          <Link to="/login" className="inline-block mt-6">
            <Button type="button">Back to sign in</Button>
          </Link>
        </CardBody>
      </Card>
    </div>
  );
};
